import React from 'react';
import { ExtendedTheme, Heading, Link, TextBlock } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles<ExtendedTheme>(theme => createStyles({
	title: {
		marginTop: 0,
		marginBottom: theme.spacing(1)
	},
	link: {
		fontSize: 'inherit'
	}
}));

const DeskEmail = ({ email }: { email: string }) => {
	const classes = useStyles();

	return (
		<div>
			<Heading
				className={classes.title}
				styleName="title1"
				xs="small"
				md="medium"
				xl="large"
			>
				Contact the Desk
			</Heading>
			<TextBlock
				shade={400}
				styleName="body"
				xs="small"
				md="medium"
				xl="large"
			>
				For general inquiries, please contact <Link className={classes.link} ignoreRouter to={`mailto:${email}`}>{email}</Link>
			</TextBlock>
		</div>
	);
}

export default DeskEmail;
